import { endpoints } from '../api/endpoints';
import { queryKeys } from './queryKeys';
import { queryConfig } from './queryConfig';
import { createListQueryHook } from './queryFactory';

export const useAbout = createListQueryHook({
  queryKey: queryKeys.aboutUs(),
  endpoint: endpoints.aboutUs,
  config: {
    staleTime: queryConfig.staleTime.short,
  },
});

